<template>
    <div>
        <my-header></my-header>
        <div class="container">
            <img src="../../assets/img/home_bg.png" alt="" class="top">
            <div class="df content">
                <div class="df info">
                    <img :src="userInfo.Avatar" alt="">
                    <p>No.{{userInfo.JobNo}}</p>
                    <p class="ft20">{{userInfo.NickName}}</p>
                </div>
                <div class="df nav">
                    <router-link tag="div" to="/message/message">消息</router-link> 
                    <router-link tag="div" to="/message/dynamic">动态</router-link>
                </div>
            </div>
            <router-view></router-view>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
import {getMessageList,setMessageRead,setDynamicRead} from "@/assets/js/modules/userApi"
export default {
  inject: ['reload'],
  data(){
      return {
          userInfo: {
              Id: "",
              Avatar: "",   //头像
              JobNo: "182904",    //工号
              Name: "王某",     //姓名
              NickName: "", //昵称
          },
          index: 0,     //用于辨别是否设置已读完成
      }
  },
  mounted(){
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      Object.keys(this.userInfo).forEach((key)=>{
          if(userInfo.hasOwnProperty(key)){
              this.userInfo[key] = userInfo[key];
          }
      })
      this.getUnreadList();
  },
  methods: {
      //获取未读列表
      getUnreadList(){
          let data = {
              UserID: this.userInfo.Id,
              Status: 0, 
          };
          getMessageList(data).then(res=>{
              if(res.data.Success){
                let list = res.data.Data.Items;
                if(list.length==0) return;
                let messageIds = [],dynamicIds = [];
                for(let i=0; i<list.length; i++){
                    if(list[i].ReadCategory==1){//消息
                        messageIds.push(list[i].Id);
                    }else if(list[i].ReadCategory==2){  //点赞
                        dynamicIds.push(list[i].Id);
                    }
                }
                //this.setMessageRead(messageIds);
                //this.setDynamicRead(dynamicIds);
              }
          })
      },
      //设为已读
      setMessageRead(Ids){
          if(Ids.length==0){
            this.index++;
            if(this.index>=2){
                this.$emit("setRead");
            }
            return;
          }
          let data = {
              Ids: Ids,
              UserID: this.userInfo.Id
          };
          setMessageRead(data).then(res=>{
              if(res.data.Success){
                  this.index++;
                  if(this.index>=2){
                    this.$emit("setRead");
                  }
              }
          })
      },
      setDynamicRead(Ids){
        if(Ids.length==0){
            this.index++;
            if(this.index>=2){
                this.$emit("setRead");
            }
            return;
          }
          let data = {
              Ids: Ids,
              UserID: this.userInfo.Id
          };
          setDynamicRead(data).then(res=>{
              if(res.data.Success){
                  this.index++;
                  if(this.index>=2){
                    this.$emit("setRead");
                  }
              }
          })
      }
  }
}
</script>
<style scoped>
.top{
    display: block;
    width: 100%;
}
.content{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #fff;
}
.info{
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 30px;
}
.info img{
    width: 135px;
    height: 135px;
    background-color: #e7e7e7;
    border: 6px solid #fff;
    border-radius: 50%;
    margin-top: -50%;
}
.info p{
    margin-top: 10px;
}
.ft20{
    font-size: 20px;
}
.nav{
    width: 100%;
    justify-content: center;
    font-size: 18px;
    color: #333;
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
}
.nav div{
    width: 100px;
    cursor: pointer;
    position: relative;
}
.nav div:first-of-type{
    margin-right: 15px;
}
.nav div::after{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    transform: scale(0,1);
    transition: transform 0.5s;
    content: "";
    background-color: #6699ff;
}
.nav .router-link-active::after{
    transform: scale(1,1);
}
</style>



// WEBPACK FOOTER //
// src/components/personMessage/index.vue